var map = {
	"./AjmResult/AjmResult": [
		80234,
		234
	],
	"./BwdResult/BwdResult": [
		35326,
		326
	],
	"./SbhoResult/SbhoResult": [
		32490,
		490
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47300;
module.exports = webpackAsyncContext;